import React, { useState, lazy, Component } from 'react';
import { Phone, Mail, MapPin, Clock, MessageCircle, AlertCircle, Send } from 'lucide-react';
import { Button } from '../components/ui/Button';
export function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });
  const [status, setStatus] = useState<'idle' | 'submitting' | 'success'>('idle');
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setStatus('submitting');
    // Simulate API call
    setTimeout(() => {
      setStatus('success');
      setFormData({
        name: '',
        email: '',
        phone: '',
        message: ''
      });
      setTimeout(() => setStatus('idle'), 3000);
    }, 1000);
  };
  const whatsappMessage = encodeURIComponent('Hello Maisha Medical Center. I have a general inquiry.');
  return <div className="min-h-screen bg-brand-light pb-20" data-id="element-641" data-mp="abcw6zy6146r">
      {/* Hero Band */}
      <div className="bg-brand-navy py-20 relative overflow-hidden" data-id="element-642" data-mp="a9a7qkcnvj45">
        <div className="max-w-brand mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-643" data-mp="15ex8513spwz9">
          <span className="text-brand-gold font-semibold tracking-wider text-sm uppercase mb-4 block" data-id="element-644" data-mp="19fh8senkviq5">
            Get In Touch
          </span>
          <h1 className="text-4xl md:text-5xl font-heading font-bold text-white mb-6" data-id="element-645" data-mp="1j6k7xawy5nms">
            Contact Us
          </h1>
          <p className="text-lg text-slate-300 max-w-2xl mx-auto leading-relaxed" data-id="element-646" data-mp="mhcn6545jijx">
            We are here to assist you with any inquiries, appointment bookings,
            or medical concerns. Reach out to us today.
          </p>
        </div>
      </div>

      <div className="max-w-brand mx-auto px-4 sm:px-6 lg:px-8 mt-16" data-id="element-647" data-mp="vjlsmgkkclqg">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12" data-id="element-648" data-mp="10hx1anz4gq73">
          {/* Left Column: Form & Emergency */}
          <div className="space-y-8" data-id="element-649" data-mp="26yimc3rozz45">
            {/* Emergency Block */}
            <div className="bg-red-50 border-l-4 border-brand-red p-6 rounded-r-2xl shadow-sm" data-id="element-650" data-mp="2bu7rqnqe8a8d">
              <div className="flex items-center gap-3 mb-2" data-id="element-651" data-mp="1m626raphk1n7">
                <AlertCircle className="w-6 h-6 text-brand-red" data-id="element-652" data-mp="1h8sapc7lcrqe" />
                <h3 className="font-heading font-bold text-lg text-brand-navy" data-id="element-653" data-mp="1had591twoao9">
                  Emergency Contact
                </h3>
              </div>
              <p className="text-slate-700 text-sm mb-3" data-id="element-654" data-mp="1r7hw3eyp4ube">
                For urgent medical assistance during our operating hours, please
                call our emergency line immediately.
              </p>
              <a href="tel:+2676540244" className="text-xl font-bold text-brand-red hover:underline" data-id="element-655" data-mp="yj3telwnx9ti">
                +267 6540244
              </a>
            </div>

            {/* Contact Form */}
            <div className="bg-white p-8 rounded-2xl shadow-soft border border-slate-100" data-id="element-656" data-mp="kqe8ylws8cyi">
              <h2 className="text-2xl font-heading font-bold text-brand-navy mb-6" data-id="element-657" data-mp="ko1hni54wq8s">
                Send us a message
              </h2>

              <form onSubmit={handleSubmit} className="space-y-5" data-id="element-658" data-mp="2red4s49edbhi">
                <div data-id="element-659" data-mp="2w5d4fh9wi7np">
                  <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-660" data-mp="2w5v4yq3lj81f">
                    Full Name *
                  </label>
                  <input required type="text" value={formData.name} onChange={e => setFormData({
                  ...formData,
                  name: e.target.value
                })} className="w-full px-4 py-3 rounded-xl border border-slate-200 focus:outline-none focus:ring-2 focus:ring-brand-navy/20 focus:border-brand-navy transition-all" placeholder="John Doe" data-id="element-661" data-mp="2hia5r79udsys" />
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-5" data-id="element-662" data-mp="1pnq0jau2p7yd">
                  <div data-id="element-663" data-mp="1trxov6wmclw2">
                    <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-664" data-mp="1tsftaqtfq6f2">
                      Email Address *
                    </label>
                    <input required type="email" value={formData.email} onChange={e => setFormData({
                    ...formData,
                    email: e.target.value
                  })} className="w-full px-4 py-3 rounded-xl border border-slate-200 focus:outline-none focus:ring-2 focus:ring-brand-navy/20 focus:border-brand-navy transition-all" placeholder="john@example.com" data-id="element-665" data-mp="256slt89bxobg" />
                  </div>
                  <div data-id="element-666" data-mp="2ewc6mjglrs8y">
                    <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-667" data-mp="2ez6qa8rsl91b">
                      Phone Number
                    </label>
                    <input type="tel" value={formData.phone} onChange={e => setFormData({
                    ...formData,
                    phone: e.target.value
                  })} className="w-full px-4 py-3 rounded-xl border border-slate-200 focus:outline-none focus:ring-2 focus:ring-brand-navy/20 focus:border-brand-navy transition-all" placeholder="+267 XXX XXXX" data-id="element-668" data-mp="13hp60sptf256" />
                  </div>
                </div>
                <div data-id="element-669" data-mp="6o5xweps3dt1">
                  <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-670" data-mp="6nnu8x0sdxb3">
                    Message *
                  </label>
                  <textarea required rows={4} value={formData.message} onChange={e => setFormData({
                  ...formData,
                  message: e.target.value
                })} className="w-full px-4 py-3 rounded-xl border border-slate-200 focus:outline-none focus:ring-2 focus:ring-brand-navy/20 focus:border-brand-navy transition-all resize-none" placeholder="How can we help you?" data-id="element-671" data-mp="fpx19cwuj8jq" />
                </div>
                <Button type="submit" variant="primary" fullWidth disabled={status === 'submitting' || status === 'success'} icon={status === 'success' ? undefined : <Send className="w-4 h-4" data-id="element-673" data-mp="ger4q55hfuom" />} data-id="element-672" data-mp="3oszr2vhevp8c">
                  {status === 'submitting' ? 'Sending...' : status === 'success' ? 'Message Sent!' : 'Send Message'}
                </Button>
              </form>
            </div>
          </div>

          {/* Right Column: Contact Details & Map */}
          <div className="space-y-8" data-id="element-674" data-mp="14znhaeqwk5rq">
            {/* Details Grid */}
            <div className="bg-white p-8 rounded-2xl shadow-soft border border-slate-100" data-id="element-675" data-mp="19ygue62a1urd">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-8" data-id="element-676" data-mp="v1pvrz0fgn2t">
                <div className="flex items-start gap-4" data-id="element-677" data-mp="10013a3392lhv">
                  <div className="w-12 h-12 bg-brand-lighter rounded-xl flex items-center justify-center text-brand-gold shrink-0" data-id="element-678" data-mp="zyg8qdgxr2k0">
                    <MapPin className="w-6 h-6" data-id="element-679" data-mp="m6rxsdifak4m" />
                  </div>
                  <div data-id="element-680" data-mp="r0nttaf4lwx5">
                    <h3 className="font-heading font-bold text-brand-navy mb-1" data-id="element-681" data-mp="r161d378nxkd">
                      Location
                    </h3>
                    <p className="text-slate-600 text-sm leading-relaxed" data-id="element-682" data-mp="h8qim3o4b4yf">
                      Tsabong, Botswana
                      <br data-id="element-683" data-mp="3b1w6reejpr9" />
                      (Full street address here)
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-4" data-id="element-684" data-mp="7d6ptq4uomdw">
                  <div className="w-12 h-12 bg-brand-lighter rounded-xl flex items-center justify-center text-brand-gold shrink-0" data-id="element-685" data-mp="npjxnnf52e3x">
                    <Clock className="w-6 h-6" data-id="element-686" data-mp="ipxhb540khqw" />
                  </div>
                  <div data-id="element-687" data-mp="dr447dsn2sr9">
                    <h3 className="font-heading font-bold text-brand-navy mb-1" data-id="element-688" data-mp="dui66kxe4zy6">
                      Hours
                    </h3>
                    <p className="text-slate-600 text-sm leading-relaxed" data-id="element-689" data-mp="4sip5smdlvv8">
                      Mon - Fri: 8am - 6pm
                      <br data-id="element-690" data-mp="916i4tn5vl" />
                      Sat: 9am - 1pm
                      <br data-id="element-691" data-mp="3r7btxe0b5k7x" />
                      Sun: Closed
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-4" data-id="element-692" data-mp="3m9jr3oy4kdoy">
                  <div className="w-12 h-12 bg-brand-lighter rounded-xl flex items-center justify-center text-brand-gold shrink-0" data-id="element-693" data-mp="3h9e62rmd1pfu">
                    <Phone className="w-6 h-6" data-id="element-694" data-mp="3d7k9aufad5ky" />
                  </div>
                  <div data-id="element-695" data-mp="1sprrudz82lyk">
                    <h3 className="font-heading font-bold text-brand-navy mb-1" data-id="element-696" data-mp="1sqjdox30p5bn">
                      Phone
                    </h3>
                    <a href="tel:+2676540244" className="text-slate-600 text-sm hover:text-brand-red transition-colors block" data-id="element-697" data-mp="1wpsaybx9nlby">
                      +267 6540244
                    </a>
                  </div>
                </div>

                <div className="flex items-start gap-4" data-id="element-698" data-mp="193der1m9rdv8">
                  <div className="w-12 h-12 bg-brand-lighter rounded-xl flex items-center justify-center text-brand-gold shrink-0" data-id="element-699" data-mp="1e0c7pgu75eru">
                    <Mail className="w-6 h-6" data-id="element-700" data-mp="1iz6pqgkcazaw" />
                  </div>
                  <div data-id="element-701" data-mp="1nqygar3hx511">
                    <h3 className="font-heading font-bold text-brand-navy mb-1" data-id="element-702" data-mp="1nrgkqb0bapk1">
                      Email
                    </h3>
                    <a href="mailto:bookings@maishahealth.co.bw" className="text-slate-600 text-sm hover:text-brand-red transition-colors block" data-id="element-703" data-mp="q9gi8qd7qvnr">
                      bookings@maishahealth.co.bw
                    </a>
                  </div>
                </div>
              </div>

              <hr className="my-8 border-slate-100" data-id="element-704" data-mp="ywte7ytsntfs" />

              <div className="text-center" data-id="element-705" data-mp="ytxdk2qkaqnn">
                <p className="text-sm text-slate-600 mb-4" data-id="element-706" data-mp="13ttn0hi13aal">
                  Prefer to chat? We are available on WhatsApp.
                </p>
                <Button href={`https://wa.me/26773241613?text=${whatsappMessage}`} target="_blank" variant="outline" icon={<MessageCircle className="w-5 h-5 text-[#25D366]" data-id="element-708" data-mp="g3pf3xxt4ods" />} className="border-slate-200 text-slate-700 hover:bg-slate-50 hover:text-brand-navy" data-id="element-707" data-mp="6501wiguvs3v">
                  Chat on WhatsApp
                </Button>
              </div>
            </div>

            {/* Google Map — Tsabong, Botswana */}
            <div className="rounded-2xl h-64 w-full overflow-hidden shadow-inner border border-slate-300" data-id="element-709" data-mp="25pz8u9nltn1c">
              <iframe title="Map of Tsabong, Botswana" src="https://www.google.com/maps?q=Tsabong,Botswana&z=13&output=embed" className="w-full h-full border-0" loading="lazy" referrerPolicy="no-referrer-when-downgrade" allowFullScreen data-id="element-710" data-mp="21onks8kdp9v9" />
            </div>
          </div>
        </div>
      </div>
    </div>;
}